import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Formik, Field, Form } from 'formik';
import { TextArea } from '@components/form';
import { Button, Row, Col, message } from 'antd';
import { object, string } from 'yup';
import PricingSummary from '@components/PricingSummary';
import PropertyActions, { PropertySelectors } from '@redux/PropertyRedux';
import API from '@utils/api';
import { getErrors } from '@utils/error';

const validationSchema = object().shape({
  notes: string().required('Please enter notes')
});

function PropertyNoteForm(props) {
  const {
    propertyPricingInfo,
    addActivePropertySetting,
    onPrev,
    propertyId,
    closeForm
  } = props;

  const initialValues = { notes: '' };

  const handleSubmit = async (values, actions) => {
    const { setSubmitting } = actions;
    setSubmitting(true);
    try {
      const { result } = await API.createPropertySettings(propertyId, {
        ...values,
        data: propertyPricingInfo
      });
      message.success('Pricings are created successfully');
      addActivePropertySetting(result);
      closeForm();
    } catch (err) {
      const error = getErrors(err);
      message.error(error.message);
    }
    setSubmitting(false);
  };

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={handleSubmit}
      validationSchema={validationSchema}
      isInitialValid={validationSchema.isValidSync(initialValues)}
      render={({ isValid, isSubmitting }) => {
        return (
          <Form className="create-form ant-form-vertical">
            <Row gutter={16}>
              <Col span={8}>
                <Field
                  component={TextArea}
                  name="notes"
                  type="text"
                  label="Notes"
                />
              </Col>
            </Row>

            <Row gutter={16}>
              <Col span={24}>
                <PricingSummary
                  pricingData={{
                    data: propertyPricingInfo
                  }}
                />
              </Col>
            </Row>

            <Row type="flex" className="action-btns">
              <Button type="dashed" onClick={onPrev} disabled={isSubmitting}>
                Prev
              </Button>

              <Button
                type="primary"
                htmlType="submit"
                disabled={!isValid || isSubmitting}
              >
                submit
              </Button>
            </Row>
          </Form>
        );
      }}
    />
  );
}

PropertyNoteForm.propTypes = {
  propertyNotes: PropTypes.any,
  propertyPricingInfo: PropTypes.object,
  onPrev: PropTypes.func,
  propertyId: PropTypes.any,
  addActivePropertySetting: PropTypes.func,
  closeForm: PropTypes.func
};

const mapStateToProps = state => ({
  propertyId: PropertySelectors.selectPropertyId(state),
  propertyPricingInfo: PropertySelectors.selectCurrentPriceSetting(state)
});

const mapDispatchToProps = dispatch => ({
  addActivePropertySetting: setting =>
    dispatch(PropertyActions.addNewPropertySetting(setting))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PropertyNoteForm);
